import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SocketProvider } from './context/SocketContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import WorkshopsPage from './pages/WorkshopsPage';
import AlertPage from './pages/AlertPage';
import LogPage from './pages/LogPage';
import SettingsPage from './pages/SettingsPage';

function AppRoutes() {
  const { operator } = useAuth();

  if (!operator) return <LoginPage />;

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<WorkshopsPage />} />
          <Route path="/alert/:workshopId" element={<AlertPage />} />
          <Route path="/log" element={<LogPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <AppRoutes />
      </SocketProvider>
    </AuthProvider>
  );
}
